import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { filter, take } from 'rxjs/operators';

import { ControllerRoute } from '../../../shared/models/enums/controller-route.enum';
import { AppSettings } from '../../models/settings/app-settings.model';
import { AppSettingsService } from '../app-settings/app-settings.service';

@Injectable({
  providedIn: 'root'
})
export abstract class BaseDataService {
  apiResourceUrl: string;
  httpClient: HttpClient;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  };

  constructor(
    protected appSettingsService: AppSettingsService,
    httpClient: HttpClient
  ) {
    this.apiResourceUrl = appSettingsService.configuration?.webApi.uri;

    this.httpClient = httpClient;

    this.appSettingsService.appSettings$
      .pipe(
        take(1),
        filter((appSettings) => !!appSettings.webApi)
      )
      .subscribe((appSettings: AppSettings) => {
        this.apiResourceUrl = appSettings.webApi.uri;
      });
  }

  public appendResource(resource: ControllerRoute): void {
    this.apiResourceUrl += resource;
  }
}
